import { NgModule } from '@angular/core';
import {  ColorPickerComponent } from '../components/color-picker.component';
import { ColorPickerModule } from 'ngx-color-picker';


@NgModule({
  declarations: [
    ColorPickerComponent
  ],
  imports:[
    ColorPickerModule
  ],
  exports:[
    ColorPickerComponent
  ]
})
export class ColorPickerComponentModule { }
